import { useAuth } from '../contexts/AuthContext';
import { Loader2, LogIn } from 'lucide-react';

const AuthGuard = ({ children }) => {
  const { authenticated, loading, login, user } = useAuth();

  // Show loading state
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800">
        <div className="text-center">
          <Loader2 className="w-16 h-16 mx-auto mb-4 text-blue-600 dark:text-blue-400 animate-spin" />
          <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-200 mb-2">
            Schema Graphos
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            Loading authentication...
          </p>
        </div>
      </div>
    );
  }

  // Show login prompt if not authenticated
  if (!authenticated) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800">
        <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-lg shadow-xl p-8 text-center">
          <div className="mb-6">
            <div className="w-20 h-20 mx-auto mb-4 bg-blue-600 dark:bg-blue-500 rounded-full flex items-center justify-center">
              <LogIn className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-3xl font-bold text-gray-800 dark:text-gray-200 mb-2">
              Schema Graphos
            </h1>
            <p className="text-gray-600 dark:text-gray-400">
              Advanced Database Modeling Tool
            </p>
          </div>
          
          <div className="mb-6">
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              Please sign in to access your models and domain libraries.
            </p>
          </div>

          <button
            onClick={login}
            className="w-full bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
          >
            <LogIn className="w-5 h-5" />
            Sign In
          </button>

          <div className="mt-6 pt-6 border-t border-gray-200 dark:border-gray-700">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Don't have an account? <a href="https://schemagraphos.com" class="text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300" data-en="Get a license" data-pt="Obtenha uma licença">Schema Graphos</a>
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Show authenticated content with user info banner (optional)
  return (
    <>
      {children}
    </>
  );
};

export default AuthGuard;
